import { Navigate, Route, Routes } from 'react-router-dom';
import Home from 'screens/Home';
import { ToastContainer } from 'react-toastify';
import { TranslatorProvider } from 'react-translate';
import Dashboard from 'screens/Dashboard';
import Unsubscribe from 'components/Unsubscribe';
import Preview from 'screens/Preview';
import Generate from 'screens/Generate';
import Staging from 'screens/Staging';

let translations = {
    locale: 'en',
    ChatBot: {
        SKIP: 'Skip',
        UNDO: 'Undo',
        PLACEHOLDER: 'Enter your message here',
        LOADING: 'Loading...'
    }
};
const BaseRoutes = (props) => {
    return (
        <TranslatorProvider translations={translations}>
            <Routes>
                <Route index element={<Home />} />
                <Route path={''} element={<Home />}>
                    <Route path="survey" element={<Dashboard />} />
                    <Route path="unsubscribe" element={<Unsubscribe />} />
                    <Route path="preview" element={<Preview />} />
                    <Route path="generate" element={<Generate />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
            />
        </TranslatorProvider>
    );
};

export default BaseRoutes;
